// extracted by mini-css-extract-plugin
export default {"container":"checkout_container__9Oxw8"};